import type { RefObject } from 'react';
import type { FieldArrayRenderProps } from 'formik';
import type { FacilityDataKey } from '../FacilityForm/facilityFormTypes';
import type { WizardFormValues } from '../../../domain/customerInquiry';

// oxlint-disable-next-line import/prefer-default-export -- shared facility step helper
export function createDeleteFacilityHandler(
  facilityKey: FacilityDataKey,
  values: WizardFormValues,
  arrayHelpers: Pick<FieldArrayRenderProps, 'remove'>,
  addFacilityButtonRef: RefObject<HTMLButtonElement | null>
) {
  return (index: number) => {
    const facilities = values[facilityKey];
    if (!facilities) {
      return;
    }
    if (index === facilities.length - 1) {
      arrayHelpers.remove(index);
      addFacilityButtonRef.current?.focus();
    } else {
      arrayHelpers.remove(index);
      const idOfNextFacility = facilities[index + 1]?.id;
      if (idOfNextFacility) {
        const nextFacilityNode = document.querySelector(
          `[data-id="${idOfNextFacility}"]`
        );
        if (nextFacilityNode instanceof HTMLElement) {
          nextFacilityNode.focus();
        }
      }
    }
  };
}
